import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

import { ComissaoEstatisticaAgrupadaResponse } from '@/core/api/sicom-api/comissoes/estatisticas/comissao-estatistica.model';
import { SegmentoRazao, montarSegmentosRazao } from './razao.model';

@Component({
    selector: 'app-razao',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './razao.html',
    styleUrl: './razao.scss'
})
export class Razao {
    itens = input<ComissaoEstatisticaAgrupadaResponse[]>([]);
    segmentos = computed<SegmentoRazao[]>(() => montarSegmentosRazao(this.itens()));
}
